import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

import results from './modules/results';

Vue.use(Vuex);

var _resultsCache = {};

function saveResult (entry) {
    if (entry && entry.id) {
        _resultsCache[entry.id] = entry;
    }
}

function getNavigatorLanguage () {
    var lang;

    if (navigator.languages && navigator.languages.length) {
        lang = navigator.languages[0];
    } else {
        lang = navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en-US';
    }

    return lang.toLowerCase();
}

var _language = getNavigatorLanguage();
console.log('Detected language:', _language);

function getMeasurementSystem () {
    if (typeof localStorage.measurementSystem === 'string') {
        return localStorage.measurementSystem;
    } else {
        return (_language.indexOf('us') >= 0) ? 'imperial' : 'metric';
    }
}

export default new Vuex.Store({
    modules: {
        results
    },
    state: {
        windowSize: window.innerWidth,
        isLoading: false,
        hasCalculated: false,
        measurementSystem: getMeasurementSystem()
    },
    getters: {
        viewport (state) {
            if (state.windowSize < 480) {
                return 0; // xs
            } else if (state.windowSize < 760) {
                return 1; // sm
            } else if (state.windowSize < 1280) {
                return 2; // md
            } else {
                return 3; // lg
            }
        }
    },
    mutations: {
        setWindowSize (state, value) {
            state.windowSize = value;
        },
        setLoading (state, value) {
            state.isLoading = !!value;
        },
        setMeasurementSystem (state, value) {
            if (value.match(/(imperial|metric)/)) {
                state.measurementSystem = value;
                localStorage.measurementSystem = value;
            }
        },
        setHasCalculated (state, value) {
            state.hasCalculated = value;
        }
    },
    actions: {
        loading ({ commit }, promise) {
            commit('setLoading', true);

            return promise.then(() => {
                commit('setLoading', false);
            }).catch(() => {
                commit('setLoading', false);
            });
        },
        getResultData ({ state, dispatch }, id) {
            if (typeof _resultsCache[id] !== 'undefined') {
                return Promise.resolve(_resultsCache[id]);
            } else {
                return dispatch('loadResult', id);
            }
        },
        changeActiveResult ({ commit, dispatch }, id) {
            return dispatch('getResultData', id).then(function (data) {
                commit('setResultData', data);
                return Promise.resolve(data);
            }).catch(function (error) {
                console.warn(error);
                commit('setResultData', null);
                return Promise.resolve(null);
            });
        },
        loadResult ({ state, commit, dispatch }, payload) {
            return axios.get('https://mrsspgr0h4.execute-api.us-west-2.amazonaws.com/dev/journey/' + payload).then((response) => {
                saveResult(response.data);
                return Promise.resolve(response.data);
            });
        },
        calculateEmissions ({ state, commit }, payload) {
            var postData = {
                vehicleType: payload.vehicle,
                fuelType: payload.fuel,
                origin: payload.route.origin,
                destination: payload.route.destination
            };

            return axios.post('https://mrsspgr0h4.execute-api.us-west-2.amazonaws.com/dev/journey', postData).then((response) => {
                saveResult(response.data);
                commit('setHasCalculated', true);
                return Promise.resolve(response.data);
            });
        }
    }
});
